import { computed } from 'vue'
import { useStore } from 'vuex'

export function usePersonalDetailsDisplay() {
  const store = useStore()

  const details = computed(() => store.state.donor?.userDetails?.details)

  const fullName = computed(() => {
    const d = details.value
    if (!d) return ', '
    return [d.firstname, d.lastname].filter(Boolean).join(' ')
  })

  const addressLine = computed(() => {
    const d = details.value
    if (!d) return ', '
    const parts = [
      d.addressLine1,
      d.addressLine2,
      d.city,
      d.county,
      d.postcode?.toUpperCase(),
      d.country,
    ].filter((part) => part && String(part).trim())
    return parts.join(', ')
  })

  const addressLines = computed(() => {
    const d = details.value
    if (!d) return [', ']

    const lines: string[] = []
    if (d.addressLine1?.trim()) lines.push(d.addressLine1.trim())
    if (d.addressLine2?.trim()) lines.push(d.addressLine2.trim())

    const cityCounty = [d.city, d.county]
      .filter((part) => part && String(part).trim())
      .join(', ')
    if (cityCounty) lines.push(cityCounty)

    const postcode = d.postcode?.trim()
    if (postcode) lines.push(postcode.toUpperCase())

    const country = d.country?.trim()
    if (
      country &&
      country.toLowerCase() !== 'united kingdom' &&
      country.toLowerCase() !== 'uk'
    ) {
      lines.push(country)
    }

    return lines.length ? lines : [', ']
  })

  const identitySummary = computed(() => {
    const d = details.value
    if (!d) return ''

    const name = [d.firstname, d.lastname].filter(Boolean).join(' ')
    const postcode = d.postcode?.toUpperCase()
    return [name, postcode].filter(Boolean).join(' · ')
  })

  return {
    details,
    fullName,
    addressLine,
    addressLines,
    identitySummary,
  }
}
